import { DatePipe } from '@angular/common';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { NgxSpinnerService } from 'ngx-spinner';
import { NgxImageCompressService } from 'ngx-image-compress';
import { BehaviorSubject, Observable, Subject, timer, forkJoin, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, take, takeUntil, tap, catchError } from 'rxjs/operators';
import { NgxGalleryAnimation, NgxGalleryImage, NgxGalleryImageSize, NgxGalleryOptions, NgxGalleryOrder } from 'ngx-gallery-9';
import { get as _get } from 'lodash';

import { ArchiveShipmentImagesRqst, OsdImage, OsdImageSearchFilter, OsdImageSearchRecord, SearchOsdImagesRqst, ShipmentApiService } from '@xpo-ltl-2.0/sdk-shipment';
import { NotificationService } from '@xpo-ltl/data-api';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { AuditInfo, CommodityPackageCdHelper, XrtAttributeFilter } from '@xpo-ltl/sdk-common';
import { GetServiceCenterDetailsBySicPath, LocationApiService } from '@xpo-ltl-2.0/sdk-location';

import { ConditioningService, FormatValidationService, ValidationRegexPatterns } from '@xpo-ltl/common-services';

import { ImageService } from '../../services/image.service';
import { ImageUploadFormNames } from '../../enums/image-upload-form-names.enum';
import { ImageLabelDialogComponent } from '../image-label-dialog/image-label-dialog.component';
import { ImageUploadTransformer } from './image-upload-transformer/image-upload-transformer';
import { CommodityPackageCdPipe } from '../../pipes/commodity-package-cd.pipe';
import { touchAllControls } from '../../utils/touchAllControls';
import { ProNumberFormatterPipe } from '../../pipes/pro-number-formatter.pipe';
import { DmsApiService } from '../../services/dms-api/dms-api.service';
import { proValidator } from '../../validators/pro-validator.directive';
import { ConfirmCancelData } from '../../classes/confirm-cancel-data';
import { ConfirmCancelComponent } from '../../dialogs/confirm-cancel/confirm-cancel.component';
import { ImageUploadService } from '../../services/image-upload-service/image-upload.service';
import { ColorsEnum } from '../../enums/colors.enum';
import { EnumUtil } from '../../utils/enum-util';
import { ColorsClassEnum } from '../../enums/colors.class.enum';
import { RouterUriComponents } from '../../enums/router-uri-components.enum';
import { ImageStatus } from '../../enums/image-status.enum';
import { ConfigManagerProperties } from '../../enums/config-manager-properties.enum';
import { PackaginTypeValidator } from '../../validators/packaging-type-validator';
import { LoggingApiService } from '@xpo-ltl/sdk-logging';
import { DocumentIndex, DocumentManagementApiService, GetArchivedDocumentPath } from '@xpo-ltl/sdk-documentmanagement';
import { RetrieveDmsAuthTokenRqst } from '@xpo-ltl/sdk-documentmanagement';
import { SalvageRequestService } from '../../services/salvage-request-service/salvage-request.service';
import moment from 'moment';
interface ImageUploadResult {
  res: object;
  error: any;
}
@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ImageUploadComponent implements OnInit, OnDestroy {
  constructor(
    private imageService: ImageService,
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private shipmentApiService: ShipmentApiService,
    private imageUploadTransformer: ImageUploadTransformer,
    private dmsService: DocumentManagementApiService,
    private notificationService: NotificationService,
    private configManagerService: ConfigManagerService,
    private conditioningService: ConditioningService,
    private dmsApiService: DmsApiService,
    private formatService: FormatValidationService,
    private locationApiService: LocationApiService,
    private imageuploadService: ImageUploadService,
    private imageCompress: NgxImageCompressService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private loggingApiService: LoggingApiService,
    private salvageRequestService: SalvageRequestService,
    @Inject(MAT_DIALOG_DATA) private dialogConfig: any,
    private dialogRef: MatDialogRef<ImageLabelDialogComponent>
  ) {}

  private url: any;
  private consoleEnabled = true;
  public imageAnalysisInProgress = false;
  // TODO refactoring enum styles
  public readonly ColorsEnum = EnumUtil.toArray(ColorsEnum);
  public readonly ImageUploadFormNames = ImageUploadFormNames;
  public readonly ImageStatus = ImageStatus;
  public imagestatus: ImageStatus = null;
  public matchClicked = false;
  public partialMatchClicked = false;
  public enableAuto = true;
  public unMatchClicked = false;
  public previousComments = '';
  galleryOptions: NgxGalleryOptions[];
  galleryOptions2: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[] = [];
  galleryImages2: NgxGalleryImage[] = [];
  imageColor: string[] = [];
  images: any[] = [];
  loading_complete = false;
  // public galleryImages: any[] = [];
  imageAnalyzed = false;
  imageUploadFormGroup: FormGroup;
  imagesFormGroup = this.formbuilder.group({ Images: this.images });

  public osdImage = new OsdImage();
  public uploadDisabled = false;
  public labels: string[] = [];
  public masterLabels = new BehaviorSubject<string[]>([]);
  public imageReadStatus = new BehaviorSubject<string>('');
  public tmp_files: File[] = [];
  public fupload: any;
  public options: string[] = [];
  public loadingDMSImages = false;
  public selectedImages: number[] = [];
  public filteredOptions: Observable<string[]>;
  public filteredOptionsModel: Observable<string[]>;
  public filteredOptionsSerialNbr: Observable<string[]>;
  public filteredOptionsPackageCd: Observable<string[]>;
  public filteredOptionsDesc: Observable<string[]>;
  public inValidSubject = new BehaviorSubject(false);
  public readyToSave = new BehaviorSubject(false);
  public errorsSubject: BehaviorSubject<String[]> = new BehaviorSubject([]);
  public imageRecord = new OsdImageSearchRecord();
  public proNumberFormatter = new ProNumberFormatterPipe(this.conditioningService);
  public retrieveDmsAuthTokenResp: any;
  public inValid$ = this.inValidSubject.asObservable();
  public dmsTimestamps: string[] = [];
  public imgResultAfterCompress = '';
  public disableDelete = false;
  public completedArchiving = new BehaviorSubject(false);
  public unsubscribe: Subject<void> = new Subject();
  public defaultErrorMessage = 'Error During Image(s) Upload';
  public alreadyMatched: string[] = [];
  public packagingListOptions: string[] = CommodityPackageCdHelper.values()
    .sort()
    .map(v => CommodityPackageCdPipe.prototype.transform(v));

  public updateIndicator = false;

  colorSearchBox: FormControl;
  public separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('autoColor') matAutocompleteColor: MatAutocomplete;
  @ViewChild('colorInput', { read: MatAutocompleteTrigger }) matAutocompleteColorTrigger: MatAutocompleteTrigger;
  @ViewChild('colorInput') colorInput: ElementRef<HTMLInputElement>;

  @ViewChild('pkgCd') matAutocompletePkgCd: MatAutocomplete;

  private _colors: string[] = [];
  public get colors(): string[] {
    return this._colors;
  }

  public set colors(value: string[]) {
    this._colors = value;
    let newStringValue = '';
    if (value && value.length) {
      newStringValue = this.colors.reduce((prev, curr) => `${prev},${curr}`);
    }
    this.imageUploadFormGroup.get(ImageUploadFormNames.Color).setValue(newStringValue);
  }

  filteredColors: Observable<string[]>;

  ngOnInit() {
    this.options = [];
    this.spinner.show();
    this.imageRecord = this.dialogConfig.result || this.imageRecord;
    if (this.imageRecord && this.imageRecord.instId) {
      this.updateIndicator = true;
      this.galleryImages = [];
      this.url = '';
      this.transformImageRecord(this.imageRecord);
    }
    this.uploadDisabled = false;
    this.completedArchiving = new BehaviorSubject(false);
    this.setFormControls();
    this.initializeSubscriptions();
    this.galleryOptions = [
      {
        width: '95%',
        height: '400px',
        thumbnailsColumns: 4,
        thumbnailsRows: 2,
        imageSize: NgxGalleryImageSize.Cover,
        preview: true,
        previewZoom: true,
        previewCloseOnClick: true,
        thumbnailsOrder: NgxGalleryOrder.Page,
        thumbnailActions: [{ icon: 'far fa-square', onClick: this.selectImage.bind(this), titleText: 'select' }],
        zoomInIcon: 'fa fa-search-plus',
        zoomOutIcon: 'fa fa-search-minus',
        rotateLeftIcon: 'fa fa-undo',
        rotateRightIcon: 'fa fa-repeat',
        previewRotate: true,
        imageAnimation: NgxGalleryAnimation.Slide,
      },
    ];
    this.galleryOptions2 = [
      {
        width: '260px',
        height: '320px',
        thumbnailsColumns: 4,
        thumbnailsRows: 2,
        imageSize: NgxGalleryImageSize.Cover,
        preview: true,
        previewZoom: true,
        previewCloseOnClick: true,
        thumbnailsOrder: NgxGalleryOrder.Page,
        zoomInIcon: 'fa fa-search-plus',
        zoomOutIcon: 'fa fa-search-minus',
        rotateLeftIcon: 'fa fa-undo',
        rotateRightIcon: 'fa fa-repeat',
        previewRotate: true,
        imageAnimation: NgxGalleryAnimation.Slide,
      },
    ];
  }

  selectImage(event, index): void {
    const selectedIndex = this.selectedImages.indexOf(this.images[index]);
    if (selectedIndex > -1) {
      this.selectedImages.splice(selectedIndex, 1);
      document.getElementsByClassName('ngx-gallery-thumbnail')[index].children[0].children[0].children[0].children[0].className = 'ngx-gallery-icon-content far fa-square';
    } else {
      this.selectedImages.push(this.images[index]);
      document.getElementsByClassName('ngx-gallery-thumbnail')[index].children[0].children[0].children[0].children[0].className = 'ngx-gallery-icon-content fas fa-check-square';
    }
  }

  ngOnDestroy(): void {
    if (this.unsubscribe) {
      this.unsubscribe.next();
      this.unsubscribe.complete();
      this.unsubscribe = null;
      this.resetFormData();
    }
    this.imageUploadFormGroup = null;
  }

  public processImage(event: any) {
    this.log('Starting Process Image');
    if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
      this.log('No Files Found. Ending Process Image');
      this.loading_complete = true;
      return;
    }
    if (event.target.files.length + this.galleryImages.length > 6) {
      alert('Total Images cannot be more than 6. Please remove images before uploading new ones.');
      return;
    }
    if (event.target.files) {
      const fileTypes = Array.from(event.target.files).map(file => {
        return file['type'];
      });
      let invalidCount = 0;
      fileTypes.forEach(type => {
        if (type !== 'image/jpg' && type !== 'image/jpeg') {
          invalidCount++;
        }
      });
      if (invalidCount > 0) {
        alert('Only JPEG/JPG images allowed. ' + invalidCount + ' file(s) of invalid type have been found.');
        return;
      }

      // event = null;
    }
    this.loading_complete = false;
    this.galleryOptions = [
      {
        width: '95%',
        height: '400px',
        thumbnailsColumns: 4,
        thumbnailsRows: 2,
        imageSize: NgxGalleryImageSize.Cover,
        preview: true,
        previewZoom: true,
        previewCloseOnClick: true,
        thumbnailsOrder: NgxGalleryOrder.Page,
        thumbnailActions: [{ icon: 'far fa-square', onClick: this.selectImage.bind(this), titleText: 'select' }],
        //  zoomInIcon: 'fa fa-search-plus',
        zoomOutIcon: 'fa fa-search-minus',
        rotateLeftIcon: 'fa fa-undo',
        rotateRightIcon: 'fa fa-repeat',
        zoomInIcon: 'fa fa-search-plus',
        previewRotate: true,
        imageAnimation: NgxGalleryAnimation.Slide,
      },
    ];
    let reader = new FileReader();
    for (let i = 0; i < event.target.files.length; i++) {
      reader = new FileReader();
      reader.onload = (events: any) => {
        this.url = events.target.result;
        //  this.images.push(this.url);

        if (this.imageCompress.byteCount(this.url) > 600000) {
          this.imageCompress.compressFile(this.url, 1, 60, 50).then(result => {
            this.imgResultAfterCompress = result;
            this.images.push(result);
            this.galleryImages.push({
              small: result,
              medium: result,
              big: result,
            });
            console.log('Before Compression size = ' + this.imageCompress.byteCount(this.url));
            console.log('after compression size = ' + this.imageCompress.byteCount(result));
            if (i + 1 === event.target.files.length) {
              this.loading_complete = true;
              this.selectedImages = [];
            }
          });
        } else {
          console.log('Not compressing since Less than 600KB');
          this.images.push(this.url);
          this.galleryImages.push({
            small: this.url,
            medium: this.url,
            big: this.url,
          });
          if (i + 1 === event.target.files.length) {
            this.loading_complete = true;
            this.selectedImages = [];
          }
        }
        this.log('Image ' + i);
      };
      reader.readAsDataURL(event.target.files[i]);
    }
    this.log('End Process Image with images length = ' + this.images.length);
  }

  private deleteImages() {
    this.log('Deleting Images ' + this.selectedImages);
    this.selectedImages.forEach(i => {
      const deleteIndex = this.images.indexOf(i);
      this.log('deleteIndex = ' + deleteIndex);
      this.images.splice(deleteIndex, 1);
      this.galleryImages.splice(deleteIndex, 1);
      this.log('New length of images = ' + this.images.length);
    });
    this.selectedImages = [];
    if (this.galleryImages.length === 0) {
      this.resetFormData();
      this.router.navigate([RouterUriComponents.IMAGE_SEARCH_PAGE]);
    }
  }

  private setFormControls() {
    if (this.osdImage) {
      this.imageUploadFormGroup = this.formbuilder.group({
        [ImageUploadFormNames.ProNbr]: [{ value: this.osdImage.proNbr, disabled: this.updateIndicator }, [Validators.required, proValidator(this.formatService)]],
        [ImageUploadFormNames.OriginProNbr]: [this.osdImage.originProNbr, [proValidator(this.formatService)]],
        [ImageUploadFormNames.InstId]: [this.osdImage.instId],
        [ImageUploadFormNames.Comment]: [this.osdImage.comment],
        [ImageUploadFormNames.ThumbnailImage]: [this.osdImage.thumbnailImage],
        [ImageUploadFormNames.ReportingSicCd]: [
          { value: this.osdImage.reportingSicCd, disabled: this.updateIndicator && !this.osdImage.overPairedWithShortInd },
          [Validators.required, Validators.pattern('[a-zA-Z]{3}')],
        ],
        [ImageUploadFormNames.PackageCd]: [{ value: this.osdImage.packageCd, disabled: this.updateIndicator }, [Validators.required, PackaginTypeValidator(this.packagingListOptions)]],
        [ImageUploadFormNames.OverPairedWithShortInd]: [this.osdImage.overPairedWithShortInd],
        [ImageUploadFormNames.PartialPairedWithShortInd]: [this.osdImage.partialPairedWithShortInd],
        [ImageUploadFormNames.Brand]: [{ value: this.osdImage.brand, disabled: this.updateIndicator }, [Validators.required]],
        [ImageUploadFormNames.ReferenceNbr]: [{ value: this.osdImage.referenceNbr, disabled: this.updateIndicator }],
        [ImageUploadFormNames.Description]: [{ value: this.osdImage.description, disabled: this.updateIndicator }, [Validators.required, Validators.maxLength(4000)]],
        [ImageUploadFormNames.Color]: [{ value: '', disabled: this.updateIndicator }, [Validators.required]],
        [ImageUploadFormNames.PiecesCount]: [
          { value: this.osdImage.piecesCount, disabled: this.updateIndicator },
          [Validators.required, Validators.min(1), Validators.pattern(ValidationRegexPatterns.numberCheck), Validators.maxLength(7)],
        ],
        [ImageUploadFormNames.LengthNbr]: [{ value: this.osdImage.lengthNbr, disabled: this.updateIndicator }, [this.numMaxLengthValidator(999.99), Validators.maxLength(5)]],
        [ImageUploadFormNames.WidthNbr]: [{ value: this.osdImage.widthNbr, disabled: this.updateIndicator }, [this.numMaxLengthValidator(999.99), Validators.maxLength(5)]],
        [ImageUploadFormNames.HeightNbr]: [{ value: this.osdImage.heightNbr, disabled: this.updateIndicator }, [this.numMaxLengthValidator(999.99), Validators.maxLength(5)]],
        [ImageUploadFormNames.SelectedTags]: [{ value: this.osdImage.selectedTags, disabled: this.updateIndicator }, [Validators.maxLength(4000)]],
        [ImageUploadFormNames.DmsUrl]: [this.osdImage.dmsUrl],
        [ImageUploadFormNames.WeightLbs]: [{ value: this.osdImage.weightLbs, disabled: this.updateIndicator }, [this.numMaxLengthValidator(99999999.99), Validators.maxLength(9)]],
        [ImageUploadFormNames.AuditInfo]: [this.osdImage.auditInfo],
        [ImageUploadFormNames.UploadDate]: [
          {
            value: this.osdImage.auditInfo ? this.osdImage.auditInfo.createdTimestamp : moment(new Date()).format('MM/DD/YYYY'),
            disabled: true,
          },
        ],
      });

      this.colorSearchBox = new FormControl({ value: '', disabled: this.updateIndicator });
      if (this.osdImage.color) {
        this.colors = this.osdImage.color.split(',');
      }
    }
    this.watchSic(this.imageUploadFormGroup.get(ImageUploadFormNames.ReportingSicCd));
    if (this.imageColor) {
      this.imageUploadFormGroup.get(ImageUploadFormNames.Color).setValue(this.imageColor);
    }
    if (this.previousComments) {
      this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).setValue('');
    }
  }

  numMaxLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control.value;

      if (!value) {
        return null;
      }
      value = parseFloat(value);
      return value < 0.0 || value > maxLength ? { maxlength: true } : null;
    };
  }

  private analyzeImages() {
    this.labels = [];

    if (this.selectedImages.length > 0) {
      this.imageAnalysisInProgress = true;
      this.observeUploadTimeout();
      this.notificationService.showSnackBarMessage('Analyzing Images', { status: 'SUCCESS' });

      const obsArray = this.getUploadImageObservables();
      forkJoin(obsArray)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(uploadResultArray => {
          // process errors
          const errorUploads = uploadResultArray.filter(uploadRes => !uploadRes.res);
          for (const uploadResult of errorUploads) {
            console.log('Error during Image analysis : error is ' + uploadResult.error);
          }

          const allErrors = errorUploads.length === uploadResultArray.length;
          if (allErrors) {
            this.notificationService.showSnackBarMessage('Error During Image Analysis', { durationInMillis: 3000, status: 'ERROR' });
          } else {
            // delay to allow this to be seen (success message is also shown)
            setTimeout(_ => this.notificationService.showSnackBarMessage(`${errorUploads.length} of the images failed during Image Analysis`, { durationInMillis: 3000, status: 'WARNING' }), 500);
          }

          // process successes
          const successUploads = uploadResultArray.filter(uploadRes => !!uploadRes.res);
          if (successUploads.length > 0) {
            for (const uploadResult of successUploads) {
              const index = uploadResultArray.indexOf(uploadResult) + 1;
              const temp_labels = this.imageService.transformToModel(uploadResult.res);
              this.labels.push(...temp_labels);
              this.log('For Image ' + index + ' - Google tags = ' + temp_labels);
            }

            if (this.labels.length > 0) {
              this.notificationService.showSnackBarMessage('Presenting Related tags', { durationInMillis: 200, status: 'SUCCESS' });
              this.openLabelDialog();
            } else if (this.labels.length === 0) {
              this.notificationService.showSnackBarMessage('No Labels Detected', { durationInMillis: 3000, status: 'WARNING' });
            }
            this.imageAnalyzed = true;
          }

          this.imageAnalysisInProgress = false;
        });
    } else {
      this.notificationService.showSnackBarMessage('No Images Selected', { durationInMillis: 3000, status: 'WARNING' });
    }
  }

  private getUploadImageObservables(): Observable<ImageUploadResult>[] {
    return this.selectedImages.map(img =>
      this.imageService.uploadImage(img).pipe(
        map(
          result =>
            ({
              res: result,
              error: undefined,
            } as ImageUploadResult)
        ),
        catchError(err =>
          of({
            res: undefined,
            error: err,
          } as ImageUploadResult)
        )
      )
    );
  }

  private observeUploadTimeout() {
    const waitingTime = this.configManagerService.getSetting<number>(ConfigManagerProperties.imageAnalysisWaitingTime);
    const timeout = timer(waitingTime);
    timeout.subscribe(() => {
      if (this.imageAnalysisInProgress) {
        this.unsubscribe.next();
        this.imageAnalysisInProgress = false;
        this.notificationService.showSnackBarMessage('Upload timeout for image analysis', { durationInMillis: 3000, status: 'WARNING' });
      }
    });
  }

  private initializeSubscriptions() {
    this.imageuploadService.uploadEvent.subscribe(uploadEvent => {
      this.filteredOptionsPackageCd = this.configureFilter(ImageUploadFormNames.PackageCd, this.packagingListOptions);

      this.processImage(uploadEvent);
    });
    this.imageUploadFormGroup.get(ImageUploadFormNames.ProNbr).valueChanges.subscribe(value => {
      if (value.length >= 9) {
        this.imageUploadFormGroup.get(ImageUploadFormNames.ProNbr).setValue(this.proNumberFormatter.transform(value), { emitEvent: false });
      }
      if (this.imageUploadFormGroup.get(ImageUploadFormNames.ProNbr).value === '000-000000') {
        this.imageUploadFormGroup.get(ImageUploadFormNames.ProNbr).setValue('', { emitEvent: false });
      }
    });
    this.imageUploadFormGroup.get(ImageUploadFormNames.OriginProNbr).valueChanges.subscribe(value => {
      if (value.length >= 9) {
        this.imageUploadFormGroup.get(ImageUploadFormNames.OriginProNbr).setValue(this.proNumberFormatter.transform(value), { emitEvent: false });
      }
      if (this.imageUploadFormGroup.get(ImageUploadFormNames.OriginProNbr).value === '000-000000') {
        this.imageUploadFormGroup.get(ImageUploadFormNames.OriginProNbr).setValue('', { emitEvent: false });
      }
    });
    this.filteredColors = this.colorSearchBox.valueChanges.pipe(
      startWith(null),
      map((color: string | null) => (color ? this._filterColor(color) : this.ColorsEnum.slice())),
      map((colors: string[]) => colors.filter(color => (this.colors.includes(color) ? false : true)))
    );
  }

  private saveImage() {
    if (!this.imageAnalyzed) {
      this.notificationService.showSnackBarMessage('Please Analyze atleast one image', { durationInMillis: 3000, status: 'ERROR' });
      this.imageUploadFormGroup.markAllAsTouched();
      return;
    }
    const validForm = this.imageUploadFormGroup.valid;
    this.resizeImage(this.images[0], 200, 200);
    this.readyToSave.next(false);
    this.alreadyMatched = [];
    this.errorsSubject.next([]);
    this.inValidSubject.next(false);
    this.salvageRequestService.updateSalvageButtonVisibility(true);
    if (this.imageUploadFormGroup.valid) {
      const matched = this.xrtSearch();

      this.readyToSave.pipe(take(1),takeUntil(this.unsubscribe)).subscribe(value => {
        if (value === true) {
          if (this.alreadyMatched.length !== 0) {
            this.showDuplicateDialog(this.alreadyMatched[0])
              .pipe(takeUntil(this.unsubscribe))
              .subscribe(confirmResp => {
                if (confirmResp) {
                  this.archiveImage(this.images);
                }
              });
          } else {
            this.archiveImage(this.images);
          }
        }
      });
    } else {
      this.imageUploadFormGroup.markAllAsTouched();
      this.imageUploadFormGroup.updateValueAndValidity();
      this.notificationService.showSnackBarMessage('Please correct the errors shown above', { durationInMillis: 5000, status: 'error' });
      this.errorsSubject.next(this.getErrors(this.imageUploadFormGroup));
      this.inValidSubject.next(true);
      return;
    }
  }

  cancel() {
    this.resetFormData();
    this.notificationService.showSnackBarMessage('Cancelling', { durationInMillis: 100, status: 'SUCCESS' });
    this.salvageRequestService.updateSalvageButtonVisibility(true);
    this.router.navigate([RouterUriComponents.OVERAGE]);
  }

  cancelDialog() {
    this.dialogRef.close('');
  }

  openLabelDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.position = {
      bottom: '10%',
      left: '10%',
    };
    dialogConfig.width = '85%';
    dialogConfig.maxHeight = '65%';
    dialogConfig.minHeight = '50%';
    if (this.labels && this.labels.length > 0) {
      dialogConfig.data = { labels: this.labels };
      this.dialog
        .open(ImageLabelDialogComponent, dialogConfig)
        .afterClosed()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(savedLabels => {
          if (savedLabels) {
            this.imageUploadFormGroup.get(ImageUploadFormNames.SelectedTags).setValue(savedLabels);
            const savedln = savedLabels;
            this.options = savedLabels.filter(x => {
              if (x.length < 30) {
                return x;
              }
            });
            if (this.enableAuto) {
              this.setFilteredOptions();
            }
          }
        });
    } else {
      this.notificationService.showSnackBarMessage('No Labels Detected', { durationInMillis: 5000, status: 'error' });
    }
  }

  private _filter(value: string, options: string[]): string[] {
    if (
      value
        .toUpperCase()
        .substring(value.lastIndexOf(',') + 1)
        .trim().length < 2
    ) {
      return null;
    }
    if (value.length >= 2) {
      const filterValue = value
        .toUpperCase()
        .substring(value.lastIndexOf(',') + 1)
        .trim();

      return options.filter(option => option.toUpperCase().includes(filterValue));
    }
  }

  private _filterPkgCd(value: string, options: string[]): string[] {
    const filterValue = value
      .toUpperCase()
      .substring(value.lastIndexOf(',') + 1)
      .trim();

    return options.filter(option => {
      if (filterValue.length === 3) {
        const keyValue = option
          .toUpperCase()
          .split('-')[0]
          .trim();
        return filterValue === keyValue;
      } else if (filterValue.length < 3) {
        const values = option.toUpperCase().split('-');
        return values[0].trim().startsWith(filterValue) || values[1].trim().startsWith(filterValue);
      }
      return option.toUpperCase().includes(filterValue);
    });
  }

  private setFilteredOptions() {
    this.filteredOptions = this.configureFilter(ImageUploadFormNames.Brand, this.options);
    this.filteredOptionsSerialNbr = this.configureFilter(ImageUploadFormNames.ReferenceNbr, this.options.sort());
    this.filteredOptionsDesc = this.configureFilter(ImageUploadFormNames.Description, this.options);
  }

  private configureFilter(field, options) {
    if (field === ImageUploadFormNames.PackageCd) {
      const filteredOptions = this.imageUploadFormGroup.get(field).valueChanges.pipe(
        startWith(''),
        map(value => this._filterPkgCd(value, options))
      );
      return filteredOptions;
    } else {
      const filteredOptions = this.imageUploadFormGroup.get(field).valueChanges.pipe(
        startWith(''),
        debounceTime(350),
        map(value => this._filter(value, options))
      );
      return filteredOptions;
    }
  }

  private generateErrorNotifications() {
    this.imageUploadFormGroup.updateValueAndValidity();
    // this.errorsSubject.next(this.getErrors(this.invoiceRuleFormGroup));
    this.inValidSubject.next(true);
  }

  private resetErrorSubjects() {
    this.errorsSubject.next([]);
    this.inValidSubject.next(false);
  }

  private getErrors(formGroup: FormGroup, errors: any = {}, errorsArr: any = []) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control.errors && control instanceof FormControl) {
        // errors[field] = control.errors;
        errorsArr.push(field);
      }
      if (control instanceof FormGroup) {
        if (control.errors) {
          // form group level error
          errorsArr.push(field);
        }
        Object.keys(control.controls).forEach(fkey => {
          if (control.get(fkey).errors) {
            errorsArr.push(field + fkey);
          }
        });
      }
    });
    // errorsArr = errorsArr.map(v => ErrorPipe.prototype.transform(v));
    return errorsArr;
  }

  public hasError(error: string, formGrp?: FormGroup, field?: ImageUploadFormNames): boolean {
    if (formGrp && formGrp.hasError(error)) {
      return formGrp.hasError(error) && formGrp.touched;
    } else if (formGrp && field) {
      return formGrp.get(field).hasError(error) && formGrp.get(field).touched;
    }
  }

  private archiveImage(files: any[]) {
    if (files && files.length > 0) {
      const totalImages = files.length;
      let currentImage = 0;
      const retrieveDmsAuthTokenRqst = new RetrieveDmsAuthTokenRqst();
      this.dmsService
        .retrieveDmsAuthToken(retrieveDmsAuthTokenRqst)
        .toPromise()
        .then(resp => {
          const token = JSON.parse(JSON.stringify(resp)).access_token;
          console.log('Token = ' + token);
          this.retrieveDmsAuthTokenResp = token;
          const images: any[] = [];
          files.forEach(file => {
            images.push(
              file
                .replace('data:image/jpeg;base64,', '')
                .replace('data:image/png;base64,', '')
                .replace('data:image/tiff;base64,', '')
            );
          });
          currentImage++;
          const docIndexes: DocumentIndex[] = [];
          const docIndex = new DocumentIndex();
          docIndex.tag = 'PRO';
          docIndex.value = this.imageUploadFormGroup.get(ImageUploadFormNames.ProNbr).value;
          docIndexes.push(docIndex);
          const httpParams = { headers: { dmsAuth: this.retrieveDmsAuthTokenResp, docClass: 'OSDF', corpCode: 'DEMO' } };
          const archiverqst = new ArchiveShipmentImagesRqst();
          archiverqst.dmsAuth = this.retrieveDmsAuthTokenResp;
          archiverqst.documents = images;
          archiverqst.indices = docIndexes;

          this.shipmentApiService
            .archiveShipmentImages(archiverqst)
            .toPromise()
            .then(
              response => {
                this.dmsTimestamps = _get(response, 'docArchiveTimestamps');
                this.imageUploadFormGroup.get(ImageUploadFormNames.DmsUrl).setValue(this.dmsTimestamps.toString());
                this.shipmentApiService
                  .upsertShipmentOverageImage(this.imageUploadTransformer.toUpsertShipmentImageDetailsRqst(this.imageUploadFormGroup.getRawValue()))
                  .pipe(take(1))
                  .subscribe(
                    response => {
                      this.loggingApiService.setContext('PRO', this.imageUploadFormGroup.get(ImageUploadFormNames.ProNbr).value);
                      this.loggingApiService.setContext('SIC', this.imageUploadFormGroup.get(ImageUploadFormNames.ReportingSicCd).value);
                      this.loggingApiService.info('Create Overage Image', 'Create', 'Create');
                      this.notificationService.showSnackBarMessage('Image(s) Saved Succesfully', { durationInMillis: 3000, status: 'SUCCESS' });
                      this.resetFormData();
                      this.router.navigate([RouterUriComponents.IMAGE_SEARCH_PAGE]);
                    },
                    errorM => {
                      this.notificationService.showSnackBarMessage(errorM?.error?.moreInfo?.[0]?.message ?? this.defaultErrorMessage, { durationInMillis: 3000, status: 'ERROR' });
                    }
                  );
              },
              error => {
                this.log(JSON.stringify(error));
                this.notificationService.showSnackBarMessage(error?.error?.moreInfo?.[0]?.message ?? this.defaultErrorMessage, { durationInMillis: 3000, status: 'ERROR' });
              }
            );
        });
    }
  }

  private resizeImage(base64, maxWidth, maxHeight) {
    // Max size for thumbnail
    if (typeof maxWidth === 'undefined') {
      maxWidth = 200;
    }
    if (typeof maxHeight === 'undefined') {
      maxHeight = 200;
    }

    // Create and initialize two canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const canvasCopy = document.createElement('canvas');
    const copyContext = canvasCopy.getContext('2d');

    // Create original image
    const img = new Image();
    img.src = base64;

    // Determine new ratio based on max size
    let ratio = 1;
    if (img.width > maxWidth) {
      ratio = maxWidth / img.width;
    } else if (img.height > maxHeight) {
      ratio = maxHeight / img.height;
    }

    // Draw original image in second canvas
    canvasCopy.width = img.width;
    canvasCopy.height = img.height;
    copyContext.drawImage(img, 0, 0);

    // Copy and resize second canvas to first canvas
    canvas.width = img.width * ratio;
    canvas.height = img.height * ratio;
    ctx.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height);
    this.imageUploadFormGroup.get(ImageUploadFormNames.ThumbnailImage).setValue(canvas.toDataURL());
  }

  private validateSicCode(sicCode: string) {
    const sicrqst = new GetServiceCenterDetailsBySicPath();
    sicrqst.sicCd = sicCode.trim().toUpperCase();
    this.locationApiService
      .getServiceCenterDetailsBySic(sicrqst, { loadingOverlayEnabled: false, toastOnError: false })
      .toPromise()
      .then(
        response => {
          if (response && response.sicCd === sicCode && response.sicCd !== '000') {
            this.imageUploadFormGroup.get(ImageUploadFormNames.ReportingSicCd).setErrors(null);
          } else {
            this.imageUploadFormGroup.get(ImageUploadFormNames.ReportingSicCd).setErrors({ invalidSicCode: true });
          }
        },
        () => {
          // this.notificationService.showSnackBarMessage('SIC Cannot be validated since Location service is down', { durationInMillis: 3000, status: 'WARNING' });
          this.imageUploadFormGroup.get(ImageUploadFormNames.ReportingSicCd).setErrors({ invalidSicCode: true });
        }
      );
  }

  private watchSic(watchControl: AbstractControl) {
    watchControl.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unsubscribe), debounceTime(100)).subscribe(value => {
      if (value && value.length === 3) {
        this.validateSicCode(value);
      }
    });
  }

  colorClass(color: string) {
    return ColorsClassEnum[color];
  }

  addColor(event: MatChipInputEvent): void {
    // Add color only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocompleteColor.isOpen) {
      const input = event.input;
      const value = event.value;

      this.addColorToArray(value);

      // Reset the input value
      if (input) {
        input.value = '';
      }

      this.colorSearchBox.setValue(null);
    }
  }

  private _filterColor(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.ColorsEnum.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  selectedColor(event: MatAutocompleteSelectedEvent): void {
    this.addColorToArray(event.option.viewValue);
    this.colorInput.nativeElement.value = '';
    this.colorSearchBox.setValue(null);
  }

  removeColor(color: string): void {
    const index = this.colors.indexOf(color);

    if (index >= 0) {
      const colors = this.colors.slice();
      colors.splice(index, 1);
      this.colors = colors;
    }
  }

  private xrtSearch() {
    console.log('Search value start = ' + this.alreadyMatched.length);
    const matched: string[] = [];
    const refNbr = new XrtAttributeFilter();
    refNbr.equals = this.imageUploadFormGroup.get(ImageUploadFormNames.ReferenceNbr).value;

    if (refNbr.query) {
      const filter: OsdImageSearchFilter = new OsdImageSearchFilter();
      const request = new SearchOsdImagesRqst();
      filter.referenceNbr = refNbr;
      request.filter = filter;
      this.shipmentApiService
        .searchOsdImages(request)
        .pipe(takeUntil(this.unsubscribe))
        .toPromise()
        .then(res => {
          if (res) {
            if (_get(res, 'result').length > 0) {
              this.alreadyMatched.push('Reference Number');
            }
          }
          this.readyToSave.next(true);
        });
    } else {
      this.readyToSave.next(true);
    }
    console.log('Search value End = ' + this.alreadyMatched.length);
  }

  public showDuplicateDialog(factor: string): Observable<boolean> {
    return this.showConfirmCancelDialog(
      'Duplicate Image(s) Found based on ' + factor + ' value',
      '<p>Please review it to ensure Duplicates are not created.</p><p>How do you wish to continue?</p>',
      'Cancel Submission',
      'Save Photo'
    );
  }

  public showConfirmCancelDialog(title: string, message: string, cancelButtonText: string, confirmButtonText: string): Observable<boolean> {
    const subject = new Subject<boolean>();

    const data = new ConfirmCancelData(title, message, cancelButtonText, confirmButtonText);
    const dialogRef = this.dialog.open(ConfirmCancelComponent, { data: data, disableClose: true });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((results: boolean) => {
        subject.next(results);
        subject.complete();
      });

    return subject.asObservable();
  }

  private log(msg: any) {
    if (this.consoleEnabled) {
      console.log(msg);
    }
  }

  private transformImageRecord(imageRecord: OsdImageSearchRecord) {
    if (imageRecord.instId) {
      this.osdImage.proNbr = imageRecord.proNbr;
      this.osdImage.instId = imageRecord.instId;
      this.osdImage.thumbnailImage = imageRecord.thumbnailImage;
      this.osdImage.reportingSicCd = imageRecord.reportingSicCd;
      this.osdImage.overPairedWithShortInd = imageRecord.overPairedWithShortInd;
      this.osdImage.description = imageRecord.description;
      this.imageColor = imageRecord.color ? imageRecord.color.split(',') : [];
      this.osdImage.lengthNbr = imageRecord.lengthNbr;
      this.osdImage.widthNbr = imageRecord.widthNbr;
      this.osdImage.heightNbr = imageRecord.heightNbr;
      this.osdImage.dmsUrl = imageRecord.dmsUrl;
      this.osdImage.auditInfo = new AuditInfo();
      this.osdImage.auditInfo.createdTimestamp = imageRecord.createdTimestamp;
      this.osdImage.packageCd = imageRecord.packageCd;
      this.osdImage.piecesCount = imageRecord.piecesCount;
      this.osdImage.referenceNbr = imageRecord.referenceNbr;
      this.osdImage.originProNbr = imageRecord.originProNbr;
      this.osdImage.comment = imageRecord.comments;
      this.previousComments = imageRecord.comments;
      this.osdImage.selectedTags = imageRecord.selectedTags;
      this.osdImage.weightLbs = imageRecord.weightLbs;
      this.osdImage.brand = imageRecord.brand;
      this.osdImage.partialPairedWithShortInd = imageRecord.partialPairedWithShortInd;
      if (this.osdImage.overPairedWithShortInd) {
        this.imagestatus = ImageStatus.Matched;
      } else if (this.osdImage.partialPairedWithShortInd) {
        this.imagestatus = ImageStatus.PartialMatched;
      } else {
        this.imagestatus = ImageStatus.UnMatched;
      }
    }

    if (this.osdImage.dmsUrl) {
      this.loadDMSImages(this.osdImage.dmsUrl, imageRecord.createdTimestamp);
    }
  }

  private loadDMSImages(dmsIds: string, createdDate: Date) {
    this.images = [];
    this.galleryImages2 = [];
    // Load Images array
    const retrieveDmsAuthTokenRqst = new RetrieveDmsAuthTokenRqst();
    this.dmsService
      .retrieveDmsAuthToken(retrieveDmsAuthTokenRqst)
      .toPromise()
      .then(resp => {
        const token = JSON.parse(JSON.stringify(resp)).access_token;
        console.log('Token = ' + token);
        const path = new GetArchivedDocumentPath();
        path.corpCode = this.configManagerService.getSetting<string>(ConfigManagerProperties.dmsCorpCode);
        path.docClass = 'OSDF';

        const httpParams = { headers: { dmsAuth: token } };

        const dmsUrls = dmsIds.toString().split(',');
        if (dmsUrls) {
          this.loadingDMSImages = true;
          dmsUrls.forEach(url => {
            const tmst = url.replace(/"/g, '');
            path.docArchiveTimestamp = tmst as any;
            this.dmsService.getArchivedDocument(path, { rendition: '' }, {}, httpParams).subscribe(
              img => {
                const obj = JSON.parse(JSON.stringify(img));
                const localImage = obj.document.binary
                  .replace('data:image/jpeg;base64,', '')
                  .replace('data:image/png;base64,', '')
                  .replace('data:image/tiff;base64,', '');
                let decodedImg = '';
                const cutOffDate = moment(new Date('1/26/2019'));
                const crtdDate = moment(new Date(createdDate));
                decodedImg = 'data:image/jpeg;base64,' + localImage;
                this.images.push(decodedImg);
                this.galleryImages2.push({ small: decodedImg, medium: decodedImg, big: decodedImg });
                this.loadingDMSImages = false;
              },
              error => {
                const notAvailable =
                  'data:image/png;base64,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';
                this.galleryImages2.push({ small: notAvailable, medium: notAvailable, big: notAvailable });
                this.loadingDMSImages = false;
              }
            );
          });
        }
      });
  }

  private matchImage() {
    // this.imageUploadFormGroup.removeControl(ImageUploadFormNames.UploadDate);
    this.imageUploadFormGroup.get(ImageUploadFormNames.OverPairedWithShortInd).setValue(true);
    this.imageUploadFormGroup.get(ImageUploadFormNames.PartialPairedWithShortInd).setValue(false);

    if (!this.imageUploadFormGroup.get(ImageUploadFormNames.OriginProNbr).value) {
      this.imageUploadFormGroup.get(ImageUploadFormNames.OriginProNbr).setErrors({ required: true });
    } else {
      this.imageUploadFormGroup.get(ImageUploadFormNames.OriginProNbr).setErrors(null);
    }
    this.updateImage('Matched');
  }

  private unMatchImage() {
    this.imageUploadFormGroup.get(ImageUploadFormNames.OverPairedWithShortInd).setValue(false);
    this.imageUploadFormGroup.get(ImageUploadFormNames.PartialPairedWithShortInd).setValue(false);
    if (!this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).value) {
      this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).setErrors({ required: true });
    } else {
      this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).setErrors(null);
    }
    this.updateImage('UnMatched');
  }

  private partialMatchImage() {
    this.imageUploadFormGroup.get(ImageUploadFormNames.OverPairedWithShortInd).setValue(false);
    this.imageUploadFormGroup.get(ImageUploadFormNames.PartialPairedWithShortInd).setValue(true);
    if (!this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).value) {
      this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).setErrors({ required: true });
    } else {
      this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).setErrors(null);
    }
    this.updateImage('Partial Matched');
  }

  private updateImage(action: string) {
    if (this.imageUploadFormGroup.valid) {
      /* if (this.previousComments) {
        const currentComments = this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).value;
        this.imageUploadFormGroup.get(ImageUploadFormNames.Comment).setValue(this.previousComments + currentComments);
      } */
      this.shipmentApiService
        .upsertShipmentOverageImage(this.imageUploadTransformer.toUpsertShipmentImageDetailsRqst(this.imageUploadFormGroup.getRawValue(), this.previousComments))
        .pipe(take(1))
        .subscribe(resp => {
          this.dialogRef.close('Image(s) ' + action);
        });
    } else {
      this.notificationService.showSnackBarMessage('Please correct above errors before updating', { durationInMillis: 3000, status: 'ERROR' });
    }
  }

  private resetFormData() {
    this.galleryImages = [];
    this.galleryImages2 = [];
    this.images = [];
    this.options = [];
    this.labels = [];
    this.dmsTimestamps = [];
    this.selectedImages = [];
    this.filteredOptionsSerialNbr = new Observable();
    this.filteredOptionsDesc = new Observable();
    this.filteredOptions = new Observable();
    this.filteredOptionsModel = new Observable();
  }

  public toggleAutoComplete() {
    if (this.enableAuto) {
      this.enableAuto = false;
      this.filteredOptions = null;
      this.filteredOptionsSerialNbr = null;
      this.filteredOptionsDesc = null;
    } else {
      this.enableAuto = true;
      this.setFilteredOptions();
    }
  }

  onPackageCdKeydown(event): void {
    if (event.keyCode === TAB) {
      const activeOptions = this.matAutocompletePkgCd.options.filter(item => item.active);
      if (activeOptions.length > 0) {
        this.imageUploadFormGroup.get(ImageUploadFormNames.PackageCd).setValue(activeOptions[0].value);
      }
    }
  }

  addColorToArray(value: string): void {
    // Add our color if exists in colors
    const colorToAdd = (value || '').trim().toUpperCase();
    if (colorToAdd && this.ColorsEnum.includes(colorToAdd) && !this.colors.includes(colorToAdd)) {
      const colors = this.colors.slice();
      colors.push(colorToAdd);
      this.colors = colors;
    }
  }

  onColorSearchBoxKeydown(event): void {
    if (this.separatorKeysCodes.includes(event.keyCode) || event.keyCode === TAB) {
      const value = this.colorSearchBox.value;

      if (value) {
        event.preventDefault();
        this.addColorToArray(value);
        this.colorInput.nativeElement.value = '';
        this.matAutocompleteColorTrigger.closePanel();
        this.colorSearchBox.setValue(null);
      } else if (event.keyCode !== TAB) {
        event.preventDefault();
      }
    }
  }
}
